import { useMemo } from "react";
import { useInView } from "../../hooks/useInView";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { resolveIndustries } from "../../lib/homePageContent";
import "../../style/animations.css";

export default function ServiceIndustry() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const industries = useMemo(
    () => resolveIndustries(data?.industries, language),
    [data, language],
  );
  // 5 item (bawaan) = grid 5 kolom seperti semula. Kurang dari itu -> dipusatkan
  // agar tidak menumpuk di kiri saat admin mengisi lebih sedikit.
  const desktopLayout =
    industries.items.length < 5
      ? "lg:flex lg:flex-wrap lg:justify-center"
      : "lg:grid-cols-5";

  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section
      className="
        w-full

       

    lg:py-16
       

      
      ">
      <div
        ref={ref}
        className="
          w-full
         

          mx-auto
        ">
        {/* TITLE */}
        <div
          className={`
            flex
            justify-center

            mb-16

            reveal-up
            ${inView ? "is-visible" : ""}
          `}>
          <h2
            className="
              text-[#324A5A]
              text-center

              text-[40px]
              font-bold

              lg:text-[56px]
            ">
            {industries.title}
          </h2>
        </div>

        {/* CLIENT BOX */}
        <div
          className="
            w-full

            bg-white

        

            px-4
            py-12

            lg:px-16
            lg:py-16
          ">
          {/* CLIENT LIST */}
          <div
            className={`
            grid
            grid-cols-2
            sm:grid-cols-3
            ${desktopLayout}

            gap-y-6
            gap-x-4
            sm:gap-y-10
            sm:gap-x-8

            justify-center
            justify-items-center
            mx-auto
          `}>
            {industries.items.map((data, index) => (
              <div
                key={data.key}
                style={{
                  transitionDelay: inView ? `${index * 80}ms` : "0ms",
                }}
                className={`
    reveal-scale
    ${inView ? "is-visible" : ""}

    w-full
    max-w-[245px]
    min-h-[100px]
    py-5
    sm:h-[115px]
    sm:py-0

    rounded-[24px]
    sm:rounded-[32px]

    bg-gradient-to-br
    from-[#3DA4A8]
    to-[#2C4858]

    flex
    flex-col
    items-center
    justify-center
    gap-2

    text-white
    text-center
    px-2

    transition-all
    duration-300

    hover:scale-105
    hover:shadow-lg
  `}>
                <img
                  src={data.icon}
                  alt={data.name}
                  className="w-[32px] h-[32px] sm:w-[40px] sm:h-[40px] object-contain"
                />

                <p className="text-[13px] sm:text-[16px] font-normal break-words">
                  {data.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
